import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { theme, pageTitleStyle, pageTitleTextStyle } from '../../theme';

const BASE = '/api';
function authFetch(url, opts = {}) {
  const token = localStorage.getItem('arcus_token');
  return fetch(url, { ...opts, headers: { 'Content-Type': 'application/json', ...(opts.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) } });
}

function fmtDate(v) {
  if (!v) return '—';
  const d = new Date(v);
  if (isNaN(d)) return '—';
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
    + ' ' + d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

export default function DemandesEtude({ produit = 'gf' }) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const isRcPro = produit === 'rc_pro';

  const load = useCallback(async () => {
    setLoading(true); setError('');
    try {
      const r = await authFetch(`${BASE}/polices/demandes-etude?produit=${produit}`);
      const data = await r.json();
      if (!r.ok) { setError(data.error || 'Erreur'); setRows([]); return; }
      setRows(Array.isArray(data) ? data : []);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }, [produit]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div style={{ ...pageTitleStyle, marginBottom: 16 }}>
        <span style={pageTitleTextStyle}>{isRcPro ? t('rcpro_studies.title') : t('gf_studies.title')}</span>
        <span style={{ marginLeft: 'auto', fontSize: 13, color: theme.textSecondary }}>
          {rows.length} {rows.length !== 1 ? t('gf_studies.count_plural') : t('gf_studies.count')}
        </span>
      </div>

      {error && <div style={{ color: theme.statut.decline.fg, marginBottom: 12, fontSize: 13 }}>⚠ {error}</div>}

      {loading ? (
        <div style={{ padding: 24, color: theme.textSecondary, fontSize: 14 }}>{t('common.loading')}</div>
      ) : rows.length === 0 ? (
        <div style={{ padding: 32, textAlign: 'center', color: theme.textTertiary, fontSize: 14,
          background: theme.surface, borderRadius: theme.radiusLg, border: `0.5px solid ${theme.border}` }}>
          {t('gf_studies.empty')}
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ borderBottom: `0.5px solid ${theme.borderStrong}`,
                color: theme.textTertiary, fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.05em' }}>
                {[t('gf_studies.col_client'), t('gf_studies.col_broker'), t('gf_studies.col_submitter'),
                  t('gf_studies.col_date'), t('gf_studies.col_actions')].map((h, i) => (
                  <th key={i} style={{ textAlign: i === 4 ? 'right' : 'left', padding: '10px 12px', fontWeight: 500, whiteSpace: 'nowrap' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id} style={{ borderBottom: `0.5px solid ${theme.border}` }}>
                  <td style={{ padding: '11px 12px' }}>
                    <button onClick={() => navigate(`/clients/${r.client_id}/detail`)}
                      style={{ background: 'none', border: 'none', padding: 0, color: theme.text, fontWeight: 600, cursor: 'pointer', textAlign: 'left' }}>
                      {r.client_nom || '—'}
                    </button>
                    {r.client_pays && <div style={{ fontSize: 11, color: theme.textTertiary, marginTop: 1 }}>{r.client_pays}</div>}
                  </td>
                  <td style={{ padding: '11px 12px', color: theme.text }}>{r.courtier_nom || '—'}</td>
                  <td style={{ padding: '11px 12px', color: theme.text }}>
                    {r.demandeur_nom || '—'}
                    {r.demandeur_email && <div style={{ fontSize: 11, color: theme.textTertiary, marginTop: 1 }}>{r.demandeur_email}</div>}
                  </td>
                  <td style={{ padding: '11px 12px', whiteSpace: 'nowrap', fontSize: 12, color: theme.textSecondary }}>{fmtDate(r.gf_soumis_le)}</td>
                  <td style={{ padding: '11px 12px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <button onClick={() => navigate(isRcPro ? `/polices/${r.id}` : `/gf/${r.id}`)}
                      style={{ background: theme.orange, color: '#fff', border: 'none', borderRadius: 7,
                        padding: '7px 14px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer' }}>
                      {t('gf_studies.study_btn')}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
